export default __webpack_public_path__ + "static/media/quiz-bg.7323f7d6.png";